<template>
  <div style="height:100vh;">
    <van-cell-group>
      <van-cell
        v-for="(item, index) in afterSaleResult"
        :key="index"
        :title="item.updateTime"
        :label="item.remark"
        :label-class="index !== 0 ? 'label-class' : ''"
        :border="false"
      ></van-cell>
    </van-cell-group>
    <van-button class="revoke-btn" @click="revoke" v-if="showRevokeBtn"
      >撤销申请</van-button
    >
  </div>
</template>

<script>
import { queryPost } from "@/api/common";
import { formatDateMoment } from "@/utils/date-time";
import { Dialog, Toast } from "vant";
export default {
  data() {
    return {
      couponId: this.$route.query.id,
      afterSaleResult: [],
      showRevokeBtn: true
    };
  },
  created() {
    this.getAfterSaleRecord();
  },
  methods: {
    getAfterSaleRecord() {
      let url = "order/couponBusiness/queryCouponAfterSaleRecord";
      let params = {
        couponId: this.couponId
      };
      queryPost(url, params).then(async res => {
        var afterSaleResult = res.data.data.results;
        await afterSaleResult.forEach(item => {
          item.updateTime = formatDateMoment(item.updateTime);

        });
        var temp = JSON.parse(JSON.stringify(afterSaleResult[0]));
        temp.remark = "工作人员将在三个工作日内为您审核";
        afterSaleResult.splice(1, 0, temp);
        this.afterSaleResult = afterSaleResult;
        const lastStatus =this.afterSaleResult[this.afterSaleResult.length-1].afterSalesStatus
        console.log(lastStatus)
        if(lastStatus === "4" ||
            lastStatus === "2" ||
            lastStatus === "3"){
              this.showRevokeBtn = false;
            }
      });
    },
    revoke() {
      Dialog.confirm({
        message: "确认撤销退款申请？"
      })
        .then(() => {
          let url = "order/couponBusiness/revokeCouponRefund";
          let params = {
            couponId: this.couponId
          };
          queryPost(url, params).then(async res => {
            if (res.data.code === "0000") {
              Toast.success("撤销成功！");
              await this.getAfterSaleRecord();
            } else {
              Toast.fail(res.data.message);
            }
          });
        })
        .catch(() => {
          Toast.fail("已取消");
        });
    }
  }
};
</script>

<style lang="less" scoped>
.label-class {
  color: #3688ff;
}
.revoke-btn {
  position: absolute;
  bottom: 0;
  right: 0;
  margin: 17px;
}
</style>
